import { Observable } from "rxjs"
import EmployeeCategory from "./LabServiceModel/EmployeeCategory"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function EmployeeCategoriesGetObservable(id?: number): Observable<EmployeeCategory[]> {
  if (id === undefined) {
    return ObservableFromFetch<EmployeeCategory[]>("RandomTest/GetEmployeeCategory")
  }
  else {
    const requestBody: string = new URLSearchParams({
      regModeID: id.toString()
    }).toString()
    return ObservableFromFetch<EmployeeCategory[]>("RandomTest/GetEmployeeCategoryWithRegulatoryModeID?" + requestBody)
  }
}